const CircleDecorator = ({ ...rest }) => (
  <svg width="33" height="33" viewBox="0 0 33 33" {...rest}>
    <circle cx="16.8291" cy="16.1768" r="16.1689" fill="currentColor" />
  </svg>
);

export { CircleDecorator };
